// export {lodashRenderHtml_helper}

import { retrocycle } from '../../public/js/cycle/cycle';

String.prototype.trim = function () {
  return this.replace(/^\s+|\s+$/g, '');
};

Date.prototype.toOnlyDay = function () {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate());
};

Date.prototype.formatDate = function () {
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  };

  const formatter = new Intl.DateTimeFormat('ru-RU', options);

  return formatter.format(this).replace(',', '')
}

Date.prototype.toOnlyTime = function () {
  var dt;
  var ms = this.getMilliseconds();
  var s = this.getSeconds();
  var n = this.getMinutes();
  var h = this.getHours();
  dt = (((ms / 1000 + s) / 60 + n) / 60 + h) / 24;
  return dt;
};

export function in_array_helper(value, array) {
  for (let i = 0; i < array.length; i++) {
    if (array[i] == value) return true;
  }
  return false;
}

export function toOnlyDay(d) {
  if (!d) return;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

// for node-js-by-template service
const SERVICE_TZH = 0 - new Date().getTimezoneOffset() / 60;
export function getDateByTZH(formatDate, clientTZH) {
  const offset = clientTZH - SERVICE_TZH;

  return new Date(formatDate.getTime() + offset * 3600 * 1000);
}

export const formatSecondsToHHMM = (seconds) => {
  if (typeof seconds !== 'number' || isNaN(seconds) || seconds < 0) {
    return '00:00';
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

export const formatSecondsToMMSS = (seconds) => {
  if (typeof seconds !== 'number' || isNaN(seconds) || seconds < 0) {
    return '00:00';
  }

  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const formatHoursToHHMM = (hours) => {
  if (typeof hours !== 'number' || isNaN(hours) || hours < 0) {
    return '00:00';
  }

  const totalMinutes = Math.floor(hours * 60 + 1e-9);

  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;

  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
};

// Hours (decimal) -> HH:MM:SS (если 0, возвращает '0')
export const formatHoursToHHMMSS = (hours) => {
  if (typeof hours !== 'number' || isNaN(hours) || hours < 0) {
    return '00:00:00';
  }

  if (hours === 0) {
    return '0';
  }

  const totalSeconds = Math.round(hours * 3600);

  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;

  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
};

// Decimal -> HH:MM:SS
export function decimalHoursToHHMMSS(decimalHours) {
  if (isNaN(decimalHours) || decimalHours === null) {
    return ' - ';
  }
  
  const totalSeconds = Math.round(decimalHours * 3600);
  
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');
  
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

export function normalizeTimestamp(input) {
  let timestamp;

  if (typeof input === 'string') {
    timestamp = parseFloat(input);
    if (isNaN(timestamp)) {
      throw new Error("Invalid input: string is not a valid number");
    }
  } else if (typeof input === 'number') {
    timestamp = input;
  } else {
    throw new Error("Invalid input type. Expected number or string.");
  }

  if (timestamp < 10_000_000_000) {
    return Math.floor(timestamp * 1000);
  } else {
    return Math.floor(timestamp);
  }
}

export function getPercent(num, total, roundTo = 0) {
  if (total == 0) return 0;
  return myRoundNumber_helper((num / total) * 100, roundTo);
}

// секунды, миллисекунды -> Date
export function timestampToDate(timestamp) {
  if (typeof timestamp !== 'number' && typeof timestamp !== 'string') {
    throw new Error('Timestamp must be a number or a numeric string');
  }

  const num = Number(timestamp);

  if (isNaN(num)) {
    throw new Error('Invalid timestamp');
  }

  const isSeconds = num < 10000000000;

  const date = new Date(isSeconds ? num * 1000 : num);

  if (isNaN(date.getTime())) {
    throw new Error('Invalid date');
  }

  return date;
}

export function tableFormat(value, defaultValue = ' - ') {
  if (value === undefined || value === null || value.toString() === 'NaN') {
    return defaultValue;
  }
  return value;
}

export function getTzh() {
  return 0 - new Date().getTimezoneOffset() / 60;
}

export function userIntervalCheckPositions(target, templateInterval, userTimeIntervals, hasSpan = true) {
  if (userTimeIntervals.length === 0) {
    return true
  }
  let targetSpan;
  if (hasSpan) {
    targetSpan = getNeighborByClass_helper(target, 'target-show-span');
  }

  const templateBeginTime = templateInterval.beginTime;
  const templateEndTime = templateInterval.endTime;
  for (let i = 0; i < userTimeIntervals.length; i++) {
    const ruleTimeBegin = userTimeIntervals[i][0];
    const ruleTimeEnd = userTimeIntervals[i][1];
    if ((!ruleTimeBegin || templateBeginTime >= ruleTimeBegin) && 
        (!ruleTimeEnd || templateEndTime <= ruleTimeEnd)) {
      return true;
    }
  }
  if (hasSpan) {
    infoShowText_helper(targetSpan, 'У вас нет доступа к отчетам с такими временными промежутками. Поменяйте время отчета и попробуйте снова.');
  }
  
  if (hasSpan) {
    target.style.background = 'yellow';
  } else {
    setElementColor_helper(target, 'orange');
  }
  
  return false;
}

export function userIntervalCheck(buttonId, templateInterval, userTimeIntervals) {
  if (userTimeIntervals.length === 0) {
    return true
  }
  const button = document.getElementById(buttonId ? buttonId : 'get-template-button');
  const targetSpan = getNeighborByClass_helper(button, 'target-show-span');

  const templateBeginTime = parseInt(templateInterval.beginTime) * 1000;
  const templateEndTime = parseInt(templateInterval.endTime) * 1000;
  for (let i = 0; i < userTimeIntervals.length; i++) {
    const ruleTimeBegin = userTimeIntervals[i][0]
    const ruleTimeEnd = userTimeIntervals[i][1]
    if ((!ruleTimeBegin || templateBeginTime >= ruleTimeBegin) && 
        (!ruleTimeEnd || templateEndTime <= ruleTimeEnd)) {
      return true
    }
  }
  infoShowText_helper(targetSpan, 'У вас нет доступа к отчетам с такими временными промежутками. Поменяйте время отчета и попробуйте снова.');
  setElementColor_helper(button, 'orange');
  return false;
}

export function setElementColor_helper(element, color) {
  if (element?.classList) {
    element.classList.remove('btn-primary');
    element.classList.remove('btn-success');
    element.classList.remove('btn-danger');
    element.classList.remove('btn-warning');
    switch(color){
      case('orange'):
        element.classList.add('btn-warning');
        break;
      case('green'):
        element.classList.add('btn-success');
        break;
      case('red'):
        element.classList.add('btn-danger');
        break;
      default:
        element.classList.add('btn-primary');
        break;
    }
  }
}

export function getUnixByDate(date) {
  if (!date) return;
  return new Date(date).getTime();
}

export function funcReplacer(field, value) {
  if (typeof field === 'object') {
    for (let key in field) {
      if (typeof field[key] === 'function') {
        try {
          const stringFunction = field[key].toString();

          // получаем аргументы как массив строк
          let args = stringFunction.replace('function', '');
          args = stringFunction.match(/\((.*)\)/)[1].split(',');

          // получаем тело функции как строку
          let body = stringFunction.replace(/(.*)\{/, '').slice(0, -1);

          field[key] = { type: 'function', args, body };
        } catch (err) {}
      }
    }
  }

  return field;
}

export function parseFuncReplacer(field, value) {
  if (value.type === 'function') {
    return new Function(value.args, value.body);
  }

  return value;
}

export const JSONRetrocycle = retrocycle;

export function concatUniqueObjectKeys(obj1, obj2) {
  const allKeys = Object.keys(obj1).concat(Object.keys(obj2));

  const uniqueKeys = [];

  for (const key of allKeys) {
    if (!uniqueKeys.includes(key)) {
      uniqueKeys.push(key);
    }
  }

  return uniqueKeys;
}

export function ucFirst_helper(str) {
  if (!str) return str;

  return str[0].toUpperCase() + str.slice(1);
}

export function wait(numberOfSeconds) {
  return new Promise((r) => setTimeout(r, numberOfSeconds * 1000));
}

function trim_helper(value) {
  return String(value).replace(/^\s+|\s+$/g, '');
}

function clearSpaces_helper(value) {
  return String(value).replace(/[\u202F\u00A0\u2000\u2001\u2003 ]/g, '');
}

function isHidden_helper(elem) {
  return !elem.offsetWidth && !elem.offsetHeight;
}

function getElemWidth_helper(elem) {
  // return elem.clientWidth + elem.scrollWidth;
  return elem.scrollWidth;
}

function tableSearch_helper() {
  // searchId, tableId, searchClasses передаются через массив addEventListener
  this.searchClasses = this.searchClasses || [];
  this.filteredCountId = this.filteredCountId || false;
  this.allCountId = this.allCountId || false;

  let allCount = 0;
  let filteredCount = 0;
  let phraseElem = document.getElementById(this.searchId);
  let table = document.getElementById(this.tableId);

  let phraseLine = phraseElem.value;
  let phrases = phraseLine.split(',');
  let regPhrases = [];
  for (let i = 0; i < phrases.length; i++) {
    regPhrases.push(new RegExp(phrases[i].trim(), 'i'));
  }

  // let regPhrase = new RegExp(phrase.value, 'i');
  let flag = false;
  for (let i = 1; i < table.rows.length; i++) {
    flag = false;
    allCount++;

    for (let j = 0; j < this.searchClasses.length; j++) {
      let foundElems = table.rows[i].getElementsByClassName(
        this.searchClasses[j],
      );
      if (!foundElems) continue;
      for (let k = 0; k < foundElems.length; k++) {
        for (let n = 0; n < regPhrases.length; n++) {
          // flag = regPhrase.test(foundElems[k].innerHTML);
          flag = regPhrases[n].test(foundElems[k].innerHTML);
          if (flag) break;
        }
        if (flag) break;
      }
      if (flag) break;
    }
    // for (let j = table.rows[i].cells.length - 1; j >= 0; j--) {
    //     flag = regPhrase.test(table.rows[i].cells[j].innerHTML);
    //     if (flag) break;
    // }
    if (flag) {
      table.rows[i].style.display = '';
      filteredCount++;
    } else {
      table.rows[i].style.display = 'none';
    }
  }
  if (this.filteredCountId) {
    document.getElementById(this.filteredCountId).textContent = filteredCount;
  }
  if (this.allCountId) {
    document.getElementById(this.allCountId).textContent = allCount;
  }
}

function actionOverTableCheckbox_helper() {
  if (!this.tableId) return;
  this.checked = this.checked || false;

  let table = document.getElementById(this.tableId);
  for (let i = 0; i < table.rows.length; i++) {
    let row = table.rows[i];
    let checkbox = row.querySelector('input[type="checkbox"]');
    if (!checkbox) continue;
    if (!this.checked) {
      // снятие галочки со всех, включая не прошедших фильтр
      checkbox.checked = false;
      continue;
    }
    if (row.style.display == 'none') {
      // на не прошедших фильтр галочку не ставим
      continue;
    }
    // на прошедших фильтр галочку ставим
    checkbox.checked = true;
  }
}

function lodashRenderHtml_helper(dataForTemplate, templateId, innerId) {
  let templateHtml = document.getElementById(templateId).innerHTML;
  let compiled = _.template(templateHtml);
  let html = compiled(dataForTemplate);

  document.getElementById(innerId).innerHTML = html;
}

function lodashRenderHtmlByTemplateHtml_helper(
  dataForTemplate,
  templateHtml,
  innerId,
) {
  let compiled = _.template(templateHtml);
  let html = compiled(dataForTemplate);

  document.getElementById(innerId).innerHTML = html;
}

export function objectsListFormColorAndTarget_helper(form_desc, buttonId = false) {
  let button = document.getElementById(buttonId || 'get-template-button');
  let targetSpan = getNeighborByClass_helper(button, 'target-show-span');

  if (form_desc.objects.length == 0) {
    infoShowText_helper(targetSpan, 'Не выбран ни один объект.');
    setElementColor_helper(button, 'orange');
    return false;
  } else {
    infoShowText_helper(targetSpan, 'Запросить отчет.');
    setElementColor_helper(button, 'blue');
  }

  return { button: button, targetSpan: targetSpan };
}

function objectsListFormSerializeArray_helper(idForm) {
  // const form_data   = $('#' + idForm).serializeArray();
  const form_data = serializeArray_helper(document.getElementById(idForm));
  let form_desc = {};
  form_desc.objects = [];
  form_data.forEach(function (element) {
    let key = element.name;
    let value = element.value;
    if (key === 'objects') {
      form_desc[key].push(value);
      return;
    }
    form_desc[key] = value;
  });

  return form_desc;
}

export function getNeighborByClass_helper(elem, className) {
  let parentE = elem.parentElement;
  return parentE.getElementsByClassName(className)[0];
}
export function throttle(fn, ms = 0) {
  let inThrottle;
  let lastFn;
  let lastTime;

  const fnCall = (...args) => {
    if (!inThrottle) {
      fn(...args);
      lastTime = Date.now();
      inThrottle = true;
    } else {
      clearTimeout(lastFn);
      lastFn = setTimeout(() => {
        if (Date.now() - lastTime >= ms) {
          fn(...args);
          lastTime = Date.now();
        }
      }, Math.max(ms - (Date.now() - lastTime), 0));
    }
  };
  return fnCall;
}

export function getDistancePoints(x1, y1, x2, y2) {
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
}

function convertdTo_dm(degrees) {
  let mydegrees, myminutes, remaining;

  if (degrees == '') {
    mydegrees = '';
    myminutes = '';
  } else {
    mydegrees = parseInt(degrees + '');
    remaining = Number(degrees) - mydegrees * 1.0;
    myminutes = remaining * 60.0;
    myminutes = Math.round(myminutes * 1000.0) / 1000.0;
  }

  return `${mydegrees}&deg;${myminutes}`;
}

function convertdTo_dms(degrees) {
  let mydegrees, myminutes, myseconds, remaining;
  if (degrees == '') {
    mydegrees = '';
    myminutes = '';
    myseconds = '';
  } else {
    mydegrees = parseInt(degrees + '');
    remaining = Number(degrees) - mydegrees * 1.0;
    const minutes = remaining * 60.0;
    myminutes = parseInt(minutes + '');
    remaining = minutes - myminutes * 1.0;
    myseconds = remaining * 60.0;
    myseconds = Math.round(myseconds * 10.0) / 10.0;
  }
  return `${mydegrees}&deg;${myminutes}&rsquo;${myseconds}&quot;`;
}

export function convertDegrees(lat = '', lon = '') {
  if (lat.toString().length !== 7 || lon.toString().length !== 7) {
    lat = Number(lat).toFixed(6);
    lon = Number(lon).toFixed(6);
  }

  return {
    // ГГ.гггггг / DD.dddddd
    lat: lat.toString(),
    lon: lon.toString(),

    // ГГ°MM.ммм' / DD°MM.mmm'
    latDM: convertdTo_dm(lat),
    lonDM: convertdTo_dm(lon),

    // ГГ°MM'СС.с" / DD°MM'SS.s"
    latDMS: convertdTo_dms(lat),
    lonDMS: convertdTo_dms(lon),
  };
}

export function roundNumber_helper(value, decimals) {
  // когда число очень маленькое и уже имеет e - это не работает!
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

export function hasDetailsRights_helper(templates_names_available_arr) {
  const detailTemplates = [
    'diagnostic',
    'diagnosticDetail',
    'descriptionDiagnostic',
    'oilPressure',
    'engineOilTemp',
    'retarderOilTemp',
  ]
  for (let key in templates_names_available_arr) {
    if (detailTemplates.includes(key)) {
      return true
    }
  }
  return false;
}

export function myRoundNumber_helper(val, order) {
  var orderMult = Math.pow(10, order);
  return Math.round(val * orderMult) / orderMult;
}

export function addFormatAndValAttributesFromLodash_getDataValue_helper(
  formatNum,
  value,
) {
  const res = {};

  if (formatNum >= 1 && formatNum <= 4) {
    if (
      formatNum == 1.5 ||
      formatNum == 1.6 ||
      formatNum == 1.1 ||
      formatNum == 1
    ) {
      value = value / 86400000 + 25569 - new Date().getTimezoneOffset() / 1440; // 1440 = 60 * 24
    }
    res['data-value'] = value;
  }

  return res;
}

function infoShowText_helper(element, msg, innerId, innerHtml) {
  if (!element || msg == undefined) return;
  element.textContent = msg;
  if (innerId) {
    try {
      const targetElement = document.getElementById(innerId);
      targetElement.dispatchEvent(new CustomEvent('before-write-event'));
      document.getElementById(innerId).innerHTML = innerHtml || msg;
    } catch (error) {}
  }
}

export function getVolationDesc_helper(id, violationsDescriptions) {
  let res = {
    description: '',
    color: '',
    selection_of_columns: '',
    importance: '',
  };
  if (!violationsDescriptions) {
    return res;
  }
  for (var k = 0; k < violationsDescriptions.length; k++) {
    if (Number(violationsDescriptions[k]['id']) === id) {
      res['description'] = violationsDescriptions[k]['description'];
      res['color'] = violationsDescriptions[k]['color'];
      res['selection_of_columns'] =
        violationsDescriptions[k]['selection_of_columns'];
      res['importance'] = violationsDescriptions[k]['importance'];
      break;
    }
  }
  return res;
}

export function getVolationDesc_helper2(v_color, violationsDescriptions) {
  const result = {};

  for (const key in v_color) {
    if (v_color.hasOwnProperty(key)) {
      const values = v_color[key];

      for(let value of values) {
        if (Array.isArray(value)) {
          continue
        }
        const parsed = parseViolationColorValue(key, value, violationsDescriptions);

        for(let col of parsed.columns) {
          result[`D${col}`] = parsed.color;
        }
      }
    }
  }    
  return result
}

// для вычисления v_color
export function parseViolationColorValue(id, hexValue, violationsDescriptions) {
  const value = parseInt(hexValue, 16);

  const color = value & 0x1F;

  const columnsShift = (value >> 28) & 0x07;

  const colMask = (value >> 5) & 0x7FFFFF;

  const colNumbers = [];
  for (let i = 0; i < 23; i++) {
    if (colMask & (1 << i)) {
      colNumbers.push(i);
    }
  }

  const res = {
    color: '',
    columns: [],
    columnsShift: 0
  }

  const violation = violationsDescriptions.find(item => item.id == id)
  const violationColors = violation.colors.split(',')
  const violationColumns = violation.columns.split(',')
  res.color = violationColors[color]
  
  for(let colNumber of colNumbers) {
    res.columns.push(violationColumns[colNumber])
  }

  res.columnsShift = columnsShift

  return res;
}

export function getTodayIntervalAsString_helper() {
  let now = new Date();

  let year = now.getFullYear();
  let month = 1 + now.getMonth();
  let day = now.getDate();

  let hours = now.getHours();
  let minutes = now.getMinutes();

  month = rotateToStringLen2_helper(month);
  day = rotateToStringLen2_helper(day);
  hours = rotateToStringLen2_helper(hours);
  minutes = rotateToStringLen2_helper(minutes);

  let unixTime = now.getTime();
  let unixTimeDayStart = unixTime - (unixTime % 86400000);
  let tzUser = now.getTimezoneOffset();
  unixTimeDayStart += tzUser * 60000;

  // 09.10.2019 11:07
  let result = {};
  let dateNow = day + '.' + month + '.' + year + ' ';
  result.timeBegin = dateNow + '00:00';
  result.timeEnd = dateNow + hours + ':' + minutes;
  result.timeBeginUnix = unixTimeDayStart;
  result.timeEndUnix = unixTimeDayStart + 86400000;

  return result;
}

export function rotateToStringLen2_helper(val) {
  val += '';
  if (val.length < 2) val = '0' + val;
  return val;
}

function getTimeFromString_helper(stringTime) {
  //для перевода datepickerTime в массив
  //поле altField работает некорректно

  if (!stringTime) return false;

  result = {};
  let arr1 = stringTime.split('.');
  if (arr1.length < 3) return false;

  let arr2 = arr1[2].split(' ');
  if (arr2.length < 2) return false;

  let arr3 = arr2[1].split(':');
  if (arr3.length < 2) return false;

  result.day = arr1[0];
  result.month = arr1[1];
  result.year = arr2[0];
  result.hours = arr3[0];
  result.minutes = arr3[1];

  if (result.day < 0 || result.day > 31) return false;
  if (result.month < 0 || result.month > 12) return false;
  if (result.year < 2018 || result.year > 2100) return false;
  if (result.hours < 0 || result.hours > 24) return false;
  if (result.minutes < 0 || result.minutes > 59) return false;

  // Это не работает для IE 11:
  // result.datetime = Date.parse(result.year+'-'+result.month+'-'+
  //   result.day+' '+result.hours+':'+result.minutes+':0');

  // YYYY-MM-DDTHH:mm:ss.sssZ - формат для IE, где Z = +hh:mm (таймзона)
  let userTime = {};
  userTime.timeNow = new Date();
  userTime.tzFullMinutes = userTime.timeNow.getTimezoneOffset();
  if (userTime.tzFullMinutes < 0) {
    userTime.tzSign = '+';
    userTime.tzFullMinutes *= -1;
  } else {
    userTime.tzSign = '-';
  }

  userTime.tzMinutes = userTime.tzFullMinutes % 60;
  userTime.tzHours = (userTime.tzFullMinutes - userTime.tzMinutes) / 60;

  userTime.tzHours += '';
  userTime.tzMinutes += '';

  if (userTime.tzHours.length < 2) userTime.tzHours = '0' + userTime.tzHours;
  if (userTime.tzMinutes.length < 2)
    userTime.tzMinutes = '0' + userTime.tzMinutes;

  userTime.tzString =
    userTime.tzSign + userTime.tzHours + ':' + userTime.tzMinutes;

  let ieStringDate =
    result.year +
    '-' +
    result.month +
    '-' +
    result.day +
    'T' +
    result.hours +
    ':' +
    result.minutes +
    ':00.000' +
    userTime.tzString;

  result.tzString = userTime.tzString;

  result.datetime = Date.parse(ieStringDate);

  return result;
}

function objectToString_helper(dict) {
  let result = '';
  if (typeof dict !== 'object') {
    return result;
  }
  for (key in dict) {
    if (result) {
      result += '&';
    }
    result += key + '=' + dict[key];
  }
  return result;
}

export const addCopyArr_helper = function (arr) {
  let arrCopy = {};
  for (let key in arr) {
    arrCopy[key] = arr[key];
  }
  return arrCopy;
};

export const addCopyArray_helper = function (arr) {
  return arr.reduce((accum, item, index) => {
    accum[index] = item;
    return accum;
  }, []);
};

export const formatTimeHelper2 = function(date, gmt = true, gmt2 = false) {
  // дд.мм.гггг чч:мм GMT
  // 03.07.2024 12:01 +6GMT
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  };

  if (gmt2) {
    options.timeZone = `Etc/GMT-${gmt2}`;
  }

  const formattedDateTime = date.toLocaleString('ru-RU', options);

  let timezoneString = `${SERVICE_TZH >= 0 ? '+' + SERVICE_TZH : SERVICE_TZH}GMT`;

  if (gmt2) {
    timezoneString = `(${gmt2 >= 0 ? '+' + gmt2 : gmt2}GMT)`;
  }

  if (!gmt) {
    return `${formattedDateTime.replace(',', '')}`;
  }
  return `${formattedDateTime.replace(',', '')} ${timezoneString}`;
}

export const formatTimeHelper3 = function(date, gmt = false) {
  // дд Месяц
  // 03 Августа
  if (!(date instanceof Date) || isNaN(date)) {
    return 'None';
  }

  const settings = {
    day: '2-digit',
    month: 'long',
  }

  if (gmt) {
    settings.timeZone = `Etc/GMT-${gmt}`;
  }

  const formatter = new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: 'long',
    // timeZone: 'Etc/GMT-5'
  });

  const parts = formatter.formatToParts(date);
  const day = parts.find(p => p.type === 'day')?.value || '';
  let month = parts.find(p => p.type === 'month')?.value || '';

  const genitiveMap = {
    'январь': 'января',
    'февраль': 'февраля',
    'март': 'марта',
    'апрель': 'апреля',
    'май': 'мая',
    'июнь': 'июня',
    'июль': 'июля',
    'август': 'августа',
    'сентябрь': 'сентября',
    'октябрь': 'октября',
    'ноябрь': 'ноября',
    'декабрь': 'декабря'
  };

  month = genitiveMap[month] || month;
  month = month.charAt(0).toUpperCase() + month.slice(1); // Первая буква заглавная

  return `${day} ${month}`;
}

export function flatArrayToPairs(postgresArray) {
  if (!postgresArray || postgresArray === "{NULL}") {
    return []
  }
  const elements = postgresArray.slice(1, -1).split(',');
  
  const parsedElements = elements.map(element => {
    if (element === 'NULL') {
      return null;
    }
    return parseInt(element, 10);
  });

  const pairs = [];
  for (let i = 0; i < parsedElements.length; i += 2) {
    pairs.push([parsedElements[i] || null, parsedElements[i + 1] || null]);
  }

  return pairs;
}

export const formatTimeHelper = function (sftime, formatString) {
  // sftime в сутках
  // formatString 'tt:nn:ss' или 'hh:nn:ss'
  let sign = sftime < 0 ? '-' : '';
  let ftime = Math.abs(sftime);
  let d = Math.floor(ftime);
  let t = Math.floor(ftime * 24);
  let h = Math.floor((ftime - d) * 24);
  let n = Math.floor(((ftime - d) * 24 - h) * 60);
  let s = Number((((ftime - d) * 24 - h) * 60 - n) * 60).toFixed();
  if (s == 60) {
    s = 0;
    n = n + 1;
    if (n == 60) {
      n = 0;
      h = h + 1;
      t = t + 1;
      if (h == 24) {
        h = 0;
        d = d + 1;
      }
    }
  }
  let dd = d < 10 ? '0' + d : d;
  let tt = t < 10 ? '0' + t : t;
  let hh = h < 10 ? '0' + h : h;
  let nn = n < 10 ? '0' + n : n;
  let ss = s < 10 ? '0' + s : s;
  //Report.Debug("ftime=" + ftime.toString() + " d=" + d.toString() + " h=" + h.toString() + " t=" + t.toString() + " n=" + n.toString() + " s=" + s.toString());

  formatString = formatString.replace(/dd/i, dd);
  formatString = formatString.replace(/d/i, d);
  formatString = formatString.replace(/tt/i, tt);
  formatString = formatString.replace(/t/i, t);
  formatString = formatString.replace(/hh/i, hh);
  formatString = formatString.replace(/h/i, h);
  formatString = formatString.replace(/nn/i, nn);
  formatString = formatString.replace(/n/i, n);
  formatString = formatString.replace(/ss/i, ss);
  formatString = formatString.replace(/s/i, s);

  return sign + formatString;
};

export const htmlspecialcharsHelper = (html) => {
  // Сначала необходимо заменить &
  html = html.replace(/&/g, '&amp;');
  // А затем всё остальное в любой последовательности
  html = html.replace(/</g, '&lt;');
  html = html.replace(/>/g, '&gt;');
  html = html.replace(/"/g, '&quot;');
  // Возвращаем полученное значение
  return html;
};

export const checkSpecVehicle = (category) => {
  return !!category && !!category.toString().startsWith('4');
};

export const formatDateHelper = function (formatDate, formatString) {
  if (formatDate instanceof Date && formatDate.getTime()) {
    let months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    let yyyy = formatDate.getFullYear();
    let yy = yyyy.toString().substring(2);
    let m = formatDate.getMonth() + 1;
    let mm = m < 10 ? '0' + m : m;
    let mmm = months[m];
    let d = formatDate.getDate();
    let dd = d < 10 ? '0' + d : d;

    let h = formatDate.getHours();
    let hh = h < 10 ? '0' + h : h;
    let n = formatDate.getMinutes();
    let nn = n < 10 ? '0' + n : n;
    let s = formatDate.getSeconds();
    let ss = s < 10 ? '0' + s : s;

    formatString = formatString.replace(/yyyy/i, yyyy);
    formatString = formatString.replace(/yy/i, yy);
    formatString = formatString.replace(/mmm/i, mmm);
    formatString = formatString.replace(/mm/i, mm);
    formatString = formatString.replace(/m/i, m);
    formatString = formatString.replace(/dd/i, dd);
    formatString = formatString.replace(/d/i, d);
    formatString = formatString.replace(/hh/i, hh);
    formatString = formatString.replace(/h/i, h);
    formatString = formatString.replace(/nn/i, nn);
    formatString = formatString.replace(/n/i, n);
    formatString = formatString.replace(/ss/i, ss);
    formatString = formatString.replace(/s/i, s);
    return formatString;
  } else {
    return ' - ';
  }
};

let issetHelper = function (r) {
  return typeof r !== 'undefined';
};

// drag and drop table rows
// var fixHelper = function(e, ui) {
// 	ui.children().each(function() {
// 		$(this).width($(this).width());
// 	});
// 	return ui;
// };
// $('.sortable-table tbody').sortable({
//     helper: fixHelper
// });

// сортировка таблицы
let tableSort_helper = function (tableId, numberColumn, option) {
  // https://plnkr.co/edit/ykQcZ8saB2Cj7knkyH0m?p=preview
  let sortedRows = Array.from(tableId.rows)
    .slice(1)
    .sort(function (rowA, rowB) {
      return rowA.cells[numberColumn].innerHTML >
        rowB.cells[numberColumn].innerHTML
        ? option
        : -option;
    });

  // tableId.tBodies[0].append(...sortedRows);
  for (let i = 0; i < sortedRows.length; i++) {
    tableId.tBodies[0].append(sortedRows[i]);
  }
};

function isEmptyObject_helper(obj) {
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      return false;
    }
  }
  return true;
}

export function stringTimeToSeconds(time) {
  const [hours, minutes, seconds] = time.split(':').map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

export const getPositionDifferenceInMeters = (posArr1, posArr2) => {
  //pi - число pi, rad - радиус сферы (Земли)
  const rad = 6372795;

  // координаты двух точек
  const llat1 = posArr1[0];
  const llong1 = posArr1[1];

  const llat2 = posArr2[0];
  const llong2 = posArr2[1];

  // в радианах
  const lat1 = (llat1 * Math.PI) / 180;
  const lat2 = (llat2 * Math.PI) / 180;
  const long1 = (llong1 * Math.PI) / 180;
  const long2 = (llong2 * Math.PI) / 180;

  // косинусы и синусы широт и разницы долгот
  const cl1 = Math.cos(lat1);
  const cl2 = Math.cos(lat2);
  const sl1 = Math.sin(lat1);
  const sl2 = Math.sin(lat2);
  const delta = long2 - long1;
  const cdelta = Math.cos(delta);
  const sdelta = Math.sin(delta);

  // вычисления длины большого круга
  let y = Math.sqrt(
    Math.pow(cl2 * sdelta, 2) + Math.pow(cl1 * sl2 - sl1 * cl2 * cdelta, 2),
  );
  let x = sl1 * sl2 + cl1 * cl2 * cdelta;
  const ad = Math.atan2(y, x);
  const dist = ad * rad;

  return dist;
};

export const addCopyObj_helper = function (arr) {
  var toString = {}.toString;
  var objType = '';
  var arrCopy = {};

  for (let key in arr) {
    if (typeof arr[key] != 'object' || arr[key] === null) {
      arrCopy[key] = arr[key];
      continue;
    }

    objType = toString.call(arr[key]);

    switch (objType) {
      case '[object Date]':
        arrCopy[key] = arr[key];
        break;

      case '[object Array]':
        if (arr[key].length) {
          arrCopy[key] = addCopyObj_helper(arr[key]);
          break;
        }
        arrCopy[key] = [];
        break;

      case '[object Object]':
        if (arr[key] === null) {
          arrCopy[key] = null;
          break;
        }

        if (isEmptyObject_helper(arr[key])) {
          arrCopy[key] = {};
          break;
        }

        arrCopy[key] = addCopyObj_helper(arr[key]);
        break;

      default:
        arrCopy[key] = {};
    }
  }

  return arrCopy;
};

export const addCopyArrOfObjects_helper = function (arr) {
  var arrCopy = [];
  for (var z = 0; z < arr.length; z++) {
    if (!(z in arr)) continue;
    arrCopy.push(addCopyObj_helper(arr[z]));
  }
  return arrCopy;
};

const formatToDisplay_helper = function (value, format) {
  if (isNaN(+value) || !format) {
    return value;
  }

  let res;
  switch (format) {
    case 0.5:
      return value;
    case 1:
      return formatDateHelper(new Date(value), 'dd.mm.yyyy hh:nn:ss');
    case 1.1:
    case 1.6:
      if (value > 0) {
        if (format == 1.1)
          return formatDateHelper(new Date(value), 'dd.mm.yyyy hh:nn:ss');
        if (format == 1.6)
          return formatDateHelper(new Date(value), 'dd.mm.yy hh:nn');
      } else {
        return value;
      }
    case 1.5:
      return formatDateHelper(new Date(value), 'dd.mm.yyyy hh:nn:ss');
    case 2:
      return formatDateHelper(new Date(value), 'dd.mm.yyyy');
    case 3:
      return formatDateHelper(new Date(value), 'hh:nn:ss');
    case 4:
      return formatTimeHelper(value, 'tt:nn:ss');
    case 5:
      res = roundNumber_helper(value, 1);
      if (isNaN(res)) return value;
      return numberWithSpaces_helper(res);
    case 5.5:
      res = roundNumber_helper(value, 1);
      if (isNaN(res)) return value;
      return numberWithSpaces_helper(res, '&nbsp;');
    case 6:
      res = roundNumber_helper(value * 100, 1);
      if (isNaN(res)) return value;
      return res + '&nbsp;%';
    case 6.5:
      res = roundNumber_helper(value, 1); // число уже в процентах
      if (isNaN(res)) return value;
      return res + '&nbsp;%';
    case 7:
      res = roundNumber_helper(value, 2);
      if (isNaN(res)) return value;
      return numberWithSpaces_helper(res);
    case 8:
      res = roundNumber_helper(value * 100, 2);
      if (isNaN(res)) return value;
      return res + '&nbsp;%';
    case 9:
      res = roundNumber_helper(value, 3);
      if (isNaN(res)) return value;
      return numberWithSpaces_helper(res);
    case 10:
      return roundNumber_helper(value * 100, 3) + '&nbsp;%';
    case 11:
      return roundNumber_helper(value, 0) + '&nbsp;%'; //число уже в процентах
    case 12:
      if (isNaN(+value)) {
        return value;
      }
      return numberWithSpaces_helper(roundNumber_helper(value, 0, '&nbsp;'));
    case 13:
      if (isNaN(+value)) {
        return value;
      }
      return numberWithSpaces_helper(roundNumber_helper(value, 1), '&nbsp;');
    case 14:
      if (isNaN(+value)) {
        return value;
      }
      return numberWithSpaces_helper(roundNumber_helper(value, 2), '&nbsp;');

    default:
      return value;
  }
};

function numberWithSpaces_helper(x, replacement = ' ') {
  const parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, replacement);
  return parts.join('.');
}

/*!
 * Serialize all form data into an array of key/value pairs
 * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {Array}       The serialized form data
 */
function serializeArray_helper(form) {
  const arr = [];
  [...form.elements].forEach(function (field) {
    if (
      !field.name ||
      field.disabled ||
      ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
    )
      return;
    if (field.type === 'select-multiple') {
      Array.prototype.slice.call(field.options).forEach(function (option) {
        if (!option.selected) return;
        arr.push({
          name: field.name,
          value: option.value,
        });
      });
      return;
    }
    if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
      return;
    arr.push({
      name: field.name,
      value: field.value,
    });
  });
  return arr;
}

function getObjectsList_helper(objTable, isCheckedOnly = false) {
  const tBodyRows = objTable.tBodies[0].rows;
  if (!tBodyRows) return [];

  return [...tBodyRows].reduce((accum, row) => {
    const id = row.id || null;
    const name = row.dataset.name || '';
    const stateNumber = row.querySelector('.search-stateNumber').innerText;
    const toTemplate = row.querySelector('.toTemplate');

    if (id !== null && toTemplate) {
      const inputToTemplate = toTemplate.querySelector(
        'input[type="checkbox"]',
      );
      const checked = Boolean(inputToTemplate && inputToTemplate.checked);
      if (!isCheckedOnly || (isCheckedOnly && checked)) {
        accum.push({ id, name, stateNumber, checked });
      }
    }

    return accum;
  }, []);
}

function roundStringTime_helper(strTime, roundTo) {
  roundTo = roundTo || 10;
  let lastSymbol = strTime.substr(strTime.length - 1, strTime.length);

  if (roundTo == 10 && lastSymbol != '0') {
    // округление до 10-ти минут
    let untilLastSymbol = strTime.substr(0, strTime.length - 1);
    return untilLastSymbol + '0';
  }

  if (roundTo == 5 && !(lastSymbol == '0' || lastSymbol == '5')) {
    // округление до 5-ти минут
    let untilLastSymbol = strTime.substr(0, strTime.length - 1);
    if (+lastSymbol < 5) {
      return untilLastSymbol + '0';
    }
    return untilLastSymbol + '5';
  }

  return strTime;
}

function medianAverage_helper(arr, minMax = null, arrFilter = () => true) {
  if (arr.length < 2) {
    const result = arr[0] || 0;
    if (minMax && result > 0) {
      minMax.min = result;
      minMax.max = result;
    }

    return result >= 0 ? result : 0;
  }

  const sorted = addCopyArray_helper(arr)
    .sort((a, b) => a - b)
    .filter(arrFilter);

  if (!sorted.length) {
    return 0;
  }

  if (sorted.length === 1) {
    const only = sorted[0];

    if (minMax && only) {
      minMax.min = only;
      minMax.max = only;
    }

    return only;
  }

  const length = sorted.length;
  const center = Math.floor(length / 2);

  if (minMax) {
    minMax.min = sorted[0];
    minMax.max = sorted[length - 1];
  }

  if (length % 2) {
    return sorted[center];
  }

  return (sorted[center] + sorted[center - 1]) / 2;
}

function arithmeticAverage_helper(arr) {
  const summ = arr.reduce(
    (accum, item) => {
      if (isNumber_helper(item)) {
        accum.summ += item;
        accum.count++;
      }
      return accum;
    },
    { summ: 0, count: 0 },
  );

  return summ.count ? summ.summ / summ.count : 0;
}

function isNumber_helper(num) {
  return typeof num === 'number' && !isNaN(num);
}

function colorHexShiftObject_helper(colorObject) {
  const opacity = colorObject.color.opacity || 1;
  const { r, g, b } = colorHexShift_helper(colorObject.color);

  colorObject.text = `rgba(${r},${g},${b},${opacity})`;
  colorObject.color = { r, g, b };
}

function colorHexShift_helper(rgbColor) {
  let { r = 0, g = 0, b = 0 } = rgbColor;
  const MAX = 255;

  b += 120;

  if (b > MAX) {
    const overflow = b - MAX;
    b -= MAX;
    g += overflow;
  }

  if (g > MAX) {
    const overflow = g - MAX;
    g -= MAX;
    r += overflow;
  }

  if (r > MAX) {
    r -= MAX;
  }

  // Этот цвет не виден при распечатке
  if (r == 255 && g == 255 && b == 210) {
    r = 75;
    g = 75;
    b = 75;
  }

  return { r, g, b };
}

function getMinMaxOfArray_helper(arr = []) {
  if (arr.length < 2) {
    const minMax = arr[0] || 0;
    return {
      min: minMax,
      max: minMax,
    };
  }

  arr.sort((a, b) => a - b);

  return {
    min: arr[0],
    max: arr[arr.length - 1],
  };
}

function replaceNbsp_helper(text) {
  return text.replace(/&nbsp;/g, ' ');
}

function doubleScroll_helper(element) {
  const scrollbar = document.createElement('div');
  scrollbar.appendChild(document.createElement('div'));
  scrollbar.style.height = '15px';
  scrollbar.style.overflow = 'auto';
  scrollbar.style.overflowY = 'hidden';
  scrollbar.firstChild.style.width = element.scrollWidth + 'px';
  scrollbar.firstChild.style.height = '15px';
  scrollbar.firstChild.style.paddingTop = '1px';
  scrollbar.firstChild.appendChild(document.createTextNode('\xA0'));
  scrollbar.onscroll = function () {
    element.scrollLeft = scrollbar.scrollLeft;
  };
  element.onscroll = function () {
    scrollbar.scrollLeft = element.scrollLeft;
  };
  element.parentNode.insertBefore(scrollbar, element);
}

function summOfArray_helper(arr) {
  // сумма чисел в массиве
  return arr.reduce((accum, value) => accum + value, 0);
}

export function getRelativeValue_helper(
  arrName,
  values,
  timeCoefficient = 1 / 24,
) {
  const {
    distance,
    motoEngineSpd,
    ptoTime,
    canExpenceSpd,
    clutchUseMoveStartExcessiveWorkSumm,
    engineBreakTime,
    rpm1900_2200Time,
  } = values;
  const multimeterBySeconds = timeCoefficient > 1 ? 86400 : 1;
  const multimeterByHours = timeCoefficient > 1 ? 1 : 24;

  switch (arrName) {
    case 'avgSpd':
      return motoEngineSpd ? distance / (motoEngineSpd / timeCoefficient) : 0;

    case 'canExpence100km':
      const { canExpence } = values;
      return distance ? (100 * canExpence) / distance : 0;

    case 'canExpence100kmMove':
      return distance ? (100 * canExpenceSpd) / distance : 0;

    case 'canExpenceLHourMove':
      return motoEngineSpd
        ? canExpenceSpd / (motoEngineSpd / timeCoefficient)
        : 0;

    case 'canExpenceLHourIdle':
      const { canExpenceNoSpd, motoEngineNoSpd } = values;
      return motoEngineNoSpd
        ? canExpenceNoSpd / (motoEngineNoSpd * multimeterByHours)
        : 0; // motoEngineNoSpd приходит в сутках

    case 'ptoEngineRpm800_1000Percent':
      const { ptoEngineRpm800_1000Time } = values;
      return ptoTime ? (100 * ptoEngineRpm800_1000Time) / ptoTime : 0;

    case 'rpmMore1200PtoPercent':
      const { rpmMore1200PtoTime } = values;
      return ptoTime ? (100 * rpmMore1200PtoTime) / ptoTime : 0;

    case 'transmission_lock_1_distPercent':
      const { transmission_lock_1_dist } = values;
      return distance ? (100 * transmission_lock_1_dist) / distance : 0;

    case 'clutchUseMoveStartExcessiveWorkPercent':
      const { clutchUseMoveStartWorkSumm } = values;
      return clutchUseMoveStartWorkSumm
        ? (100 * clutchUseMoveStartExcessiveWorkSumm) /
            clutchUseMoveStartWorkSumm
        : 0;

    case 'clutchUseMoveStartExcessiveWorkLowPercent':
      const { clutchUseMoveStartExcessiveWorkLow } = values;
      return clutchUseMoveStartExcessiveWorkSumm
        ? (100 * clutchUseMoveStartExcessiveWorkLow) /
            clutchUseMoveStartExcessiveWorkSumm
        : 0;

    case 'clutchWorkSummAvgStart':
      const { clutchWorkSumm, clutchUseMoveStartCnt } = values;
      return clutchUseMoveStartCnt ? clutchWorkSumm / clutchUseMoveStartCnt : 0;

    case 'rpm1900_2200Percent':
      return motoEngineSpd
        ? (rpm1900_2200Time * multimeterBySeconds) / motoEngineSpd
        : 0; // rpm1900_2200Time приходит в сутках

    case 'rpm1900_2200TimePercent':
      return motoEngineSpd
        ? (rpm1900_2200Time * multimeterBySeconds) / motoEngineSpd
        : 0; // rpm1900_2200Time приходит в сутках

    case 'engineBreakTimePercent':
      const { breakTime } = values;
      return breakTime ? (100 * engineBreakTime) / breakTime : 0;

    case 'pedalBreakTime100km':
      const { pedalBreakTime } = values;
      return distance ? (100 * pedalBreakTime) / distance : 0;

    case 'engineBreakTime100km':
      return distance ? (100 * engineBreakTime) / distance : 0;

    case 'kickdownCnt100km':
      const { kickdownCnt } = values;
      return distance ? (100 * kickdownCnt) / distance : 0;

    case 'absCount100km':
      const { absCount } = values;
      return distance ? (100 * absCount) / distance : 0;

    case 'ptoCnt100km':
      const { ptoCnt } = values;
      return distance ? (100 * ptoCnt) / distance : 0;

    case 'forfeitsRelative':
      const { forfeits } = values;
      return distance ? (100 * forfeits) / distance : 0;

    case 'receivedPercent':
      const { cnt_pos_missed: cnt_pos_missed_origin, cnt_real_pos } = values;
      const cnt_pos_missed = cnt_pos_missed_origin / 10;
      const cntPosRecord = cnt_real_pos + cnt_pos_missed;
      if (cntPosRecord > 0) {
        //процент прихода данных
        return 1 - cnt_pos_missed / cntPosRecord;
      }
      return 'н/д';

    default:
      return 0;
  }
}

// 83008256.6 -> 83 008 256.6
export function formatNumberWithSpaces(value) {
  if (value === null || value === undefined || value === '') {
    return value;
  }
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  if (typeof numValue !== 'number' || isNaN(numValue)) {
    return value;
  }
  
  const parts = numValue.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join('.');
}
